export default {
  SM294F42E: {
    message: "The feature you're trying to access could not be found",
  },
};
